export default "__VITE_ASSET__SZy0Logu__"